import { loadAdsignData } from "@adactiveasia/adsign-map";
import { useEffect, useState } from "react";
import { mapConfig } from "../../constants/mapConstant";
import { extractTextFromTags, getInformationAsset } from "../../helper";
import TermsConditions from "../TermsConditions";
import { useStores } from "../../use.store";

const FormConsentCheckbox = ({ checked, onChange }) => {
  const { mapStore } = useStores();
  const [dataAdsign, setDataAdsign] = useState([]);
  const [contentTermsConditions, setContentTermsConditions] = useState(null);
  const [openTnc, setOpenTnc] = useState(false);
  const [urlTnc, setUrlTnc] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (dataAdsign && dataAdsign && dataAdsign.length > 0) {
      const allPagesContent = dataAdsign
        .filter((info) => {
          // all pages
          return info.categoryId === "67bff619ce9ac1bad292948e";
        })
        .sort((a, b) => a.name.localeCompare(b.name));

      const footerData = allPagesContent.filter((data) => {
        return data.name.toLowerCase().includes("footer");
      });
      const privacyPolicy = dataAdsign
        .filter((info) => {
          return info.name.toLowerCase().includes("data privacy policy");
        })
        .sort((a, b) => a.name.localeCompare(b.name));

      if (footerData) {
        allPagesContent.map((data) => {
          if (data.name.toLowerCase().includes("terms and condition")) {
            setContentTermsConditions(data.description);
          }
        });
      }
      if (privacyPolicy) {
        setUrlTnc(getInformationAsset(privacyPolicy?.[0]?.files?.[0]?.logo));
      }
    }
  }, [dataAdsign, dataAdsign]);

  const loadData = async () => {
    if (mapStore.information) {
      setDataAdsign(mapStore.information);
    }
  };

  return (
    <div>
      <div className="flex items-center gap-2 text-xs md:text-sm text-gray-500">
        <input
          type="checkbox"
          className="size-5 rounded border-gray-300"
          checked={checked}
          onChange={onChange}
        />
        <p>
          By submitting this form, I consent to the collection, use, disclosure
          and processing of my personal data for the purposes of responding to,
          processing and handling my queries in accordance to the{" "}
          <a
            className="text-gray-700 underline cursor-pointer"
            // href={extractTextFromTags(contentTermsConditions, "p") ?? "#"}
            onClick={() => setOpenTnc(true)}
            target="_blank"
          >
            Data Protection Policy of Orchardgateway Private Limited
          </a>
          .
        </p>
      </div>

      {openTnc && (
        <TermsConditions content={urlTnc} onClose={() => setOpenTnc(false)} />
      )}
    </div>
  );
};

export default FormConsentCheckbox;
